<template>
    <el-card class="mini-box-card  box-d-card" >
        <template class="mini-card-header" #header>
            <span>Hotels</span>
            <div>

                <el-button class="ml-2 white-btn" size="small" @click="add()" >Add Hotel</el-button>
            </div>
        </template>
        <el-row v-if="enquiry.listservices.hotels.length>0">
            <el-col >
                <el-table size="small" :data="enquiry.listservices.hotels" border style="width: 100%">
                    <el-table-column prop="department" label="#"  width="40" >
                        <template #default="scope">
                            {{scope.$index+1}}
                        </template>
                    </el-table-column>

                    <el-table-column prop="vendor.vendor_name" label="Vendor"  >
                        <template #default="scope">
                            {{ scope.row.selvendor ? scope.row.selvendor.vendor_name : '' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" label="Name"  />
                    <el-table-column prop="city" label="City"  />
                    <el-table-column prop="checkin" label="Check-In"  />
                    <el-table-column prop="checkout" label="Check-Out"  />
                    <el-table-column prop="amount" label="Amount"  >
                        <template #default="scope">
                            {{Intl.NumberFormat('en-US').format(scope.row.amount)}}
                        </template>

                    </el-table-column>
                    <el-table-column prop="status" label="Status"  >
                        <template #default="scope">
                            <el-tag type="info" v-if="scope.row.status=='Pending'">Pending</el-tag>
                            <el-tag type="warning" v-else-if="scope.row.status=='Hold'">Hold</el-tag>
                            <el-tag type="success" v-else-if="scope.row.status=='Vouchered'">Vouchered</el-tag>
                            <el-tag type="danger" v-else-if="scope.row.status=='Cancelled'">Cancelled</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="deadline" label="Deadline"  />
                    <el-table-column prop="department" label="Action"  fixed="right" width="100">
                        <template #default="scope">
                            <div v-if="scope.row.id==0">
                                <el-button v-if="enquiry.permissions.servicesmanage.edit" type="primary" size="small" @click="editservice(scope.row)">
                                    <el-icon>
                                        <CirclePlus />
                                    </el-icon>
                                </el-button>
                            </div>
                            <div v-else>
                                <el-button v-if="enquiry.permissions.servicesmanage.edit" type="primary" size="small" @click="editservice(scope.row)">
                                    <el-icon>
                                        <Edit />
                                    </el-icon>
                                </el-button>
                                <el-button v-if="enquiry.permissions.servicesmanage.edit"  type="danger" size="small" @click="deleteservicee(scope.row)">
                                    <el-icon>
                                        <Delete />
                                    </el-icon>
                                </el-button>
                            </div>



                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>

    </el-card>

    <el-dialog
        v-model="dialogDelete"
        title="Delete Payment?"
        width="500"
    >

        <p>Vendor : {{ deleteService.selvendor.vendor_name }}</p>
        <p>Name : {{ deleteService.name }}</p>
        <p>City : {{ deleteService.city }}</p>
        <p>Check-In : {{ deleteService.checkin }}</p>
        <p>Check-Out : {{ deleteService.checkout }}</p>
        <p>Amount :  {{Intl.NumberFormat('en-US').format(deleteService.amount)}}</p>
        <p>Status : {{ deleteService.status }}</p>
        <p v-if="deleteService.status=='Hold'">Deadline : {{ deleteService.deadline }}</p>

        <template #footer>
            <div class="dialog-footer">
                <el-button type="primary" :disabled="deleting" @click="dialogDelete = false">Cancel</el-button>
                <el-button type="primary" :disabled="deleting" :loading="deleting" @click="deleteservicesubmit()">
                    Confirm
                </el-button>
            </div>
        </template>
    </el-dialog>

    <el-drawer  v-model="dialogAdd" direction="rtl">
        <template #header>
            <h4>Hotel</h4>
        </template>
        <template #default>
            <el-form
                ref="ruleFormRef"
                :model="form"
                status-icon
                :rules="rules"
                label-width="auto"
                class="demo-ruleForm"
                label-position="top"

            >


                <el-form-item label="Vendor" prop="vendor" >
                    <Select2 :options="form.selvendor" style="width:100%"  v-model="form.vendor_id"   :settings="vendorsajax" required/>

                </el-form-item>
                <el-form-item label="Amount" prop="amount" >
                    <el-input type="number"   v-model="form.amount" />

                </el-form-item>
                <el-form-item label="Name" prop="name" >
                    <el-input   v-model="form.name" />
                </el-form-item>
                <el-form-item label="City" prop="city" >
                    <el-input   v-model="form.city" />
                </el-form-item>
                <el-form-item label="Check-In" prop="checkin" >
                    <el-date-picker  type="date" style="width:100%"   v-model="form.checkin" format="DD-MM-YYYY" value-format="YYYY-MM-DD" />

                </el-form-item>
                <el-form-item label="Check-Out" prop="checkout" >
                    <el-date-picker  type="date" style="width:100%"   v-model="form.checkout" format="DD-MM-YYYY" value-format="YYYY-MM-DD" />

                </el-form-item>
                <el-form-item label="Status" prop="status" >
                    <el-select style="width:100%"   v-model="form.status" >
                        <el-option label="Pending"  value="Pending"></el-option>
                        <el-option label="Hold"  value="Hold"></el-option>
                        <el-option label="Vouchered"  value="Vouchered"></el-option>
                        <el-option label="Cancelled"  value="Cancelled"></el-option>
                    </el-select>

                </el-form-item>

                <el-form-item label="Deadline" prop="deadline" v-if="form.status=='Hold'">
                    <el-date-picker  type="date" style="width:100%"   v-model="form.deadline" format="DD-MM-YYYY" value-format="YYYY-MM-DD" />

                </el-form-item>

            </el-form>
        </template>
        <template #footer>
            <div style="flex: auto">
                <el-button type="primary" @click="dialogAdd=false">Cancel</el-button>
                <el-button type="primary" @click="submitForm()" :loading="loading" :disabled="loading">Submit</el-button>
            </div>
        </template>
    </el-drawer>

</template>

<script>
import {
    ElDatePicker,ElSelect,ElOption,ElLink,ElTag,ElIcon,ElTable,ElTableColumn,ElRow,ElCol,ElCard,ElDropdownItem,ElDropdownMenu,ElDropdown,ElDialog,ElButton,ElDrawer,ElForm,ElFormItem,ElInput
} from 'element-plus'
import $ from "jquery";
import { CirclePlus,Link,Edit,Delete } from '@element-plus/icons-vue'
import moment from "moment";
export default {
    name: "VendorPayments",
    props: {
        enquiry: {
            type: Object,
            default() {
                return null
            }
        },
        authuser: {
            type: Object,
            default() {
                return null
            }
        }
    },
    emits: ["saved"],
    components: {  CirclePlus,ElDatePicker,ElSelect,ElOption,Link,ElLink,ElTag,Delete,ElIcon,Edit,ElTable,ElTableColumn,ElRow,ElCol,ElCard,ElDropdownItem,ElDropdownMenu,ElDropdown,ElDialog,ElButton,ElForm,ElDrawer,ElFormItem,ElInput },
    data() {
        return {
            dialogAdd:false,
            loading:false,
            deleteService:null,
            deleting:false,
            dialogDelete:false,
            vendorsajax: {
                ajax: {
                    url: '/vendor/ajaxlist',
                    dataType: 'json',
                    delay: 250,
                    processResults: function (data) {
                        return {
                            results: $.map(data, function (item) {
                                return {
                                    text: item.name,
                                    id: item.id
                                }
                            })
                        };
                    },
                    cache: true
                }
            },
            form:{
                id:0,
                amount:'',
                checkin:'',
                checkout:'',
                city:'',
                deadline:'',
                name	:'',
                status:'Pending',
                vendor_id:'',
                selvendor:[]
            },
            rules:{
                amount:[
                    {
                        required: true, message: 'Required',
                        trigger: ['blur','change'],
                    }
                ],
                checkin:[
                    {
                        required: true, message: 'Required',
                        trigger: ['blur','change'],
                    }
                ],
                checkout:[
                    {
                        required: true, message: 'Required',
                        trigger: ['blur','change'],
                    }
                ],
                city:[
                    {
                        required: true, message: 'Required',
                        trigger: ['blur','change'],
                    }
                ],
                deadline:[
                    {
                        required: true, message: 'Required',
                        trigger: ['blur','change'],
                    }
                ],
                name:[
                    {
                        required: true, message: 'Required',
                        trigger: ['blur','change'],
                    }
                ],
                status:[
                    {
                        required: true, message: 'Required',
                        trigger: ['blur','change'],
                    }
                ],
                vendor_id:[
                    {
                        required: true, message: 'Required',
                        trigger: ['blur','change'],
                    }
                ],
            },

        }
    },
    created(){

    },
    methods:{
        add(){
            this.dialogAdd=true;
            this.form.id='';
            this.form.selvendor=[];
            this.form.name='';
            this.form.city='';
            this.form.amount='';
            this.form.status='';
            this.form.vendor_id='';
            this.form.checkin='';
            this.form.checkout='';
            this.form.deadline='';

        },
        submitForm(){
            const formEl=this.$refs.ruleFormRef;
            if (!formEl) return
            formEl.validate((valid) => {
                if (valid) {
                    this.submitadd()
                } else {
                    return false
                }
            })


        },
        submitadd(){
            let currentObj = this;
            currentObj.loading=true;
            axios.post('/enquiry/savehotelservice?eid='+this.enquiry.id,this.form).then(function (response) {
                toastr.success('Hotel Saved Succesfully.');
                currentObj.$emit("saved");
                currentObj.form.id='';
                currentObj.form.selvendor=[];
                currentObj.form.name='';
                currentObj.form.city='';
                currentObj.form.amount='';
                currentObj.form.status='';
                currentObj.form.vendor_id='';
                currentObj.form.checkin='';
                currentObj.form.checkout='';
                currentObj.form.deadline='';
                currentObj.loading=false;
                currentObj.dialogAdd=false;
            })
                .catch(function (error) {
                    if(error.response.status=="404"){
                        toastr.error(error.response.data);
                    }
                    else{
                        toastr.error('Something Wrong try again.');
                    }
                    currentObj.loading=false;
                });
        },
        editservice(hotel){

            this.form.id=hotel.id;
            this.form.name=hotel.name;
            this.form.city=hotel.city;
            this.form.amount=hotel.amount;
            this.form.status=hotel.status;
            this.form.vendor_id=hotel.vendor_id;
            if(hotel.selvendor.id){
                this.form.selvendor=[{id: hotel.selvendor.id, text: hotel.selvendor.vendor_name}];
            }
            else{
                this.form.selvendor=[];
            }

            this.form.checkin=moment(hotel.checkin, "DD-MM-YYYY").format('YYYY-MM-DD');
            this.form.checkout=moment(hotel.checkout, "DD-MM-YYYY").format('YYYY-MM-DD');
            if(hotel.deadline){
                this.form.deadline=moment(hotel.deadline, "DD-MM-YYYY").format('YYYY-MM-DD');
            }


            this.dialogAdd=true;

        },
        deleteservicee(service){
            this.deleteService=service;
            this.dialogDelete=true;
        },
        deleteservicesubmit(){
            let currentObj = this;
            currentObj.deleting=true;
            axios.post('/enquiry/deletehotelservice', {'id':this.deleteService.id}).then(function (response) {

                toastr.success('Service Deleted Succesfully.');
                currentObj.$emit("saved");
                currentObj.deleting=false;
                currentObj.dialogDelete=false;
            })
                .catch(function (error) {
                    toastr.error('Something Wrong try again.');
                    currentObj.deleting=false;
                });
        },



    }
}
</script>

<style scoped>

</style>
